import React, { useState } from 'react';
import { Button, Form, Grid, Icon, Input, Popup } from "semantic-ui-react";
import PropTypes from 'prop-types';
import { useTextResources } from '../../../../language';

const EditMultipleDiscountPercentPopup = ({ selectedRows, isOpen, setIsOpen, saveDiscounts }) => {
	const [discount, setDiscount] = useState(0);

	const onDiscountChange = (_, { value }) => {
		if (isNaN(parseInt(value))) {
			return;
		}
		if (value < 0) {
			return;
		}

		if (value > 100) {
			return;
		}

		setDiscount(parseInt(value));
	}

	const handleSaveValue = (e, value) => {
		e.stopPropagation();
		const rowsToSave = {};
		for (const row in selectedRows) {
			selectedRows[row].DiscountPercent = value;
			rowsToSave[row] = { DiscountPercent: value };
		}
		saveDiscounts(rowsToSave);
		handleClose(e);

	}
	const onSubmitDiscount = (e) => {
		handleSaveValue(e, discount);
	}

	const restoreDefault = (e) => {
		handleSaveValue(e, null);
	}

	const handleClose = (e) => {
		setDiscount(0);
		if (isOpen) {
			e.stopPropagation();
			setIsOpen(false);
		}
	}

	const togglePopup = e => {
		e.stopPropagation();
		setIsOpen(!isOpen);
	}

	const text = useTextResources();
	return (
		<Popup
			className='EditMultipleDiscountPercentPopup'
			trigger={<Icon color='green' className='pencil' onClick={togglePopup} />}
			on='click'
			position='bottom left'
			onClose={handleClose}
			open={isOpen}
			offset={[-12,3]}
			content={
				<Form onClick={e => e.stopPropagation()}>
					<Grid padded>
						<Grid.Row columns='2'>
							<Grid.Column width='2'>
								<Form.Field inline>
									<Input
										label={text('ChangeDiscounts')}
										onClick={e => e.stopPropagation()}
										type='number'
										placeholder={text('DiscountPercent')}
										min={0}
										max={100}
										step={1}
										onChange={onDiscountChange}
										value={discount}
									/>
								</Form.Field>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns='2'>
							<Grid.Column>
								<Button onClick={onSubmitDiscount} positive content={text('Save')} />
							</Grid.Column>
							<Grid.Column textAlign='right'>
								<Button negative content={text('Reset')} onClick={restoreDefault} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Form>
			}
		/>
	)
}

EditMultipleDiscountPercentPopup.propTypes = {
	selectedRows: PropTypes.object,
	saveDiscounts: PropTypes.func,
	setIsOpen: PropTypes.func,
	isOpen: PropTypes.bool,
}
export default EditMultipleDiscountPercentPopup;
